import { getAnalytics } from 'firebase/analytics';
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCp0dkFIiHJIcGjD15o-ZXekgdU6r5BRfA',
  authDomain: 'app-vpubnd-hcmc-stg.firebaseapp.com',
  projectId: 'app-vpubnd-hcmc-stg',
  storageBucket: 'app-vpubnd-hcmc-stg.firebasestorage.app',
  messagingSenderId: '149249496100',
  appId: '1:149249496100:web:d4cbf4a8d8dd17c3b874b1',
  measurementId: 'G-Q9NM5DTG39'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
